export const SIZE = [
  'small',
  'medium',
  'large',
  'xlarge',
  ''
]
